import { render } from "./LMSModule.vue?vue&type=template&id=d179e068&scoped=true"
import script from "./LMSModule.vue?vue&type=script&lang=js"
export * from "./LMSModule.vue?vue&type=script&lang=js"

import "./LMSModule.vue?vue&type=style&index=0&id=d179e068&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d179e068"

export default script